<template>
  <el-container class="body_container">
    <!--<el-row class="head_line">直播</el-row>-->
    <el-header style="height: 50px;padding:0px">
      <el-row type="flex" class="body_title">
        <el-col>留言</el-col>
        <el-col style="text-align: right;" >
          <el-form :model="searchVo" ref="search" :inline="true">
            <el-form-item class="dialog-footer">
              <!--<el-button  @click="add('addLive')" type="primary">新建</el-button>-->
              <!--添加留言弹窗组件 -->
              <add-reply ref="addBranch" v-if="addReplyVisible" :visible.sync="addReplyVisible" :values="replyId" :lawyerName="lawyerName" :videoTitle="videoTitle" @callFather="reload"></add-reply>
            </el-form-item>
            <el-form-item style="margin: 0px">
              <el-input v-model="searchVo.title" placeholder="输入内容查询" style="width: 300px">
                <el-button slot="append" @click="search" icon="el-icon-search"></el-button>
              </el-input>
              <!--<el-input placeholder="请输入内容" v-model="searchVo.title" class="input-with-select">-->
              <!--<el-button slot="append" icon="el-icon-search"></el-button>-->
              <!--</el-input>-->
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="search_result">
      <el-table :data="replys.list" :row-class-name="tableRowClassName">
        <el-table-column prop="createdBy" label="律师姓名" min-width="140px">
          <template slot-scope="scope">
            <span v-if="scope.row.look === '0'">{{scope.row.createdBy}}</span>
            <span v-else style="font-weight: bold;font-style: italic">{{scope.row.createdBy}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="直播标题" min-width="240px">
          <template slot-scope="scope">
            <span v-if="scope.row.look === '0'">{{scope.row.title}}</span>
            <span v-else style="font-weight: bold;font-style: italic">{{scope.row.title}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容" min-width="260px">
          <template slot-scope="scope">
            <span v-if="scope.row.look === '0'">{{scope.row.content}}</span>
            <span v-else style="font-weight: bold;font-style: italic">{{scope.row.content}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="msgTime" label="留言时间" min-width="200px">
          <template slot-scope="scope">
            <span v-if="scope.row.look === '0'">{{scope.row.msgTime}}</span>
            <span v-else style="font-weight: bold;font-style: italic">{{scope.row.msgTime}}</span>
          </template>
        </el-table-column>
        <!--<el-table-column prop="replyUser" label="回复人ID（名字）" width="200px"></el-table-column>-->
        <!--<el-table-column prop="replyContent" label="回复内容" width="200px"></el-table-column>-->
        <!--<el-table-column prop="replyTime" label="回复时间" width="200px"></el-table-column>-->
        <!--<el-table-column prop="status" label="状态" width="260px"></el-table-column>-->
        <el-table-column  label="是否回复"  min-width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.replyContent === null || scope.row.replyContent === ''">未回复</span>
            <span v-else >已回复</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="操作" width="80px">
          <template slot-scope="scope">
            <!--<el-button size="mini" @click="checkQuote(scope.row)">-->
            <i class="el-icon-edit" @click="checkReply(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            &nbsp;
            <i class="el-icon-delete" @click="delReply(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            <!--</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-pagination class="page"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-size="replys.rows"
                   :current-page="replys.page"
                   layout="prev, pager, next, jumper"
                   :total="replys.total">
    </el-pagination>
  </el-container>
</template>

<script>
import Reply from './reply/Reply.vue'
import reply from '@/api/reply'
export default {
  name: 'Reply',
  data () {
    return {
      lawyerName: '',
      videoTitle: '',
      replyId: null,
      addReplyVisible: false,
      replys: {
        page: 1,
        rows: 10,
        total: 0,
        list: []
      },
      searchVo: {
        title: ''
      },
      value2: '1',
      type: 'H',
      page: 1,
      size: 10
    }
  },
  methods: {
    checkReply (row) {
      row.look = '0'
      reply.msgLook({id: row.id}).then(res => {
      })
      this.replyId = row.id
      this.lawyerName = row.createdBy
      this.videoTitle = row.title
      this.addReplyVisible = true
    },
    delReply (row) {
      this.$confirm('此操作将删除该留言, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        reply.del({id: row.id}).then(res => {
          this.$message.info(res.data.message)
         if (res.data.code===0){
           this.reload()
         }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.page = val
      this.reload()
    },
    reload () {
      reply.find({page: this.page, rows: this.size }).then(res => {
        this.replys = res.data.data
        // console.log(this.replys)
      })
    },
    // add (refForm) {
    //   this.replyId = ''
    //   if (this.$refs[refForm]) {
    //     this.$refs[refForm].initForm()
    //   }
    //   this.addReplyVisible = true
    // },
    formatterColumn (row, column) {
      return row.look === '0' ? '已查看' : row.look === '1' ? '未查看' : '未知'
    },
    search () {
      this.page = 1
      this.reload()
    },
    updateData (val) {
      this.page = val
      this.reload()
    },
    tableRowClassName ({ row }) {
      if (row.look !== '0') {
        return 'readed'
      } else {
        return ''
      }
    }
  },
  components: {
    'add-reply': Reply
  },
  created () {
    this.reload()
  }
}
</script>
<style>
  .readed table{
    font-style: italic;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/video/Reply.vue